import { defineModule } from '../../engine/module';
import { ConversationScreen } from './ConversationScreen';

// The intake UI (docs/servicedesk-v2-proposal.md P5). The inbox is where work arrives before it is
// a ticket. Only the thread itself is bespoke — the rest (channels, forms, deflection) is engine
// screens, because they are catalogs and a report.

export { ConversationScreen } from './ConversationScreen';

export const intakeModule = defineModule({
  name: 'intake',
  nav: [
    {
      label: 'Service desk',
      order: 15,
      items: [{ label: 'Inbox', to: '/conversations', icon: 'inbox', key: 'x', permission: 'conversations:list' }],
    },
  ],
  screens: [
    {
      path: '/conversations',
      resource: 'conversations',
      kind: 'list',
      title: 'Inbox',
      subtitle: 'Everything being said to you — before, during and after it is a ticket.',
      columns: ['subject', 'state', 'channel_id', 'client_id', 'participant_name', 'ticket_id', 'last_message_at'],
      filters: [{ field: 'state', kind: 'chips' }, { field: 'channel_id', kind: 'select' }],
      query: { sort: '-last_message_at' },
      detailPath: '/conversations/:id',
      create: false,
    },
    { path: '/conversations/:id', resource: 'conversations', kind: 'custom', title: 'Conversation', component: ConversationScreen },
    {
      path: '/channels',
      resource: 'channels',
      kind: 'list',
      title: 'Channels',
      subtitle: 'How people reach you, where each one lands, and which ones try to answer first.',
      columns: ['name', 'kind', 'is_active', 'is_default', 'deflect_first', 'default_queue_id', 'default_ticket_type_id'],
      detailPath: '/channels/:id',
      inspector: true,
      hidden: true,
    },
    { path: '/channels/:id', resource: 'channels', kind: 'detail', builtinTabs: ['overview', 'activity'], hidden: true },
    {
      path: '/intake-forms',
      resource: 'intake-forms',
      kind: 'list',
      title: 'Intake forms',
      subtitle: 'The questions worth asking up front — so the first reply is an answer, not a question.',
      columns: ['name', 'key', 'ticket_type_id', 'is_active', 'sort'],
      detailPath: '/intake-forms/:id',
      inspector: true,
      hidden: true,
    },
    {
      path: '/intake-forms/:id',
      resource: 'intake-forms',
      kind: 'detail',
      builtinTabs: ['overview', 'activity'],
      tabs: [{ key: 'fields', label: 'Questions', icon: 'list-ordered', resource: 'intake-form-fields', filter: { form_id: ':id' }, columns: ['label', 'key', 'kind', 'is_required', 'maps_to', 'sort'] }],
      hidden: true,
    },
    {
      path: '/deflection-events',
      resource: 'deflection-events',
      kind: 'list',
      title: 'Deflection',
      // The honest number: an answer the customer came back about was never a deflection.
      subtitle: 'What we answered without a ticket — and which of those came back anyway.',
      columns: ['created_at', 'query', 'outcome', 'channel_id', 'contact_id', 'kb_article_id', 'followed_by_ticket_id'],
      filters: [{ field: 'outcome', kind: 'chips' }],
      query: { sort: '-created_at' },
      create: false,
      inspector: true,
      hidden: true,
    },
  ],
  commands: [
    { id: 'intake-inbox', label: 'Inbox', kind: 'go to', icon: 'inbox', keywords: 'conversations chat widget portal intake', run: ({ navigate }) => navigate('/conversations') },
    { id: 'intake-channels', label: 'Channels', kind: 'go to', icon: 'inbox', keywords: 'email portal widget teams sms voice', run: ({ navigate }) => navigate('/channels') },
    { id: 'intake-forms', label: 'Intake forms', kind: 'go to', icon: 'check-square', keywords: 'questions form request catalog', run: ({ navigate }) => navigate('/intake-forms') },
    { id: 'intake-deflection', label: 'Deflection', kind: 'go to', icon: 'lightbulb', keywords: 'deflected answered knowledge self service', run: ({ navigate }) => navigate('/deflection-events') },
  ],
});
